import { EMAILS } from "constants/routes";
import { checkAccess } from "helpers/auth";
import { serviceRoles } from "config/access";
import EmailsPage from "./container/EmailsPage";

export default function getRoute(userAuth) {
  const { account, rhapsody } = serviceRoles;
  const requireAuth = {
    [rhapsody.name]: [account.roles.user],
    [account.name]: [account.roles.superadmin],
  };
  return {
    path: EMAILS,
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    withSidebar: true,
    withAppBar: true,
    component: EmailsPage,
  };
}
